<script>
import { VBtn, VTooltip, VIcon } from "vuetify/lib";

import "./ActionColBtn.scss";

export default {
  props: {
    color: {
      type: String,
      default: "primary"
    },
    to: {
      type: [Object, String],
      default: null
    },
    href: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: null
    },
    small: Boolean,
    disabled: Boolean,
    loading: Boolean,
    tooltip: {
      type: String,
      default: ""
    }
  },
  render(h) {
    const { tooltip, color, to, target, href, disabled, loading } = this;
    const icon = h(VIcon, { attrs: { small: this.small } }, [
      this.$slots.default
    ]);
    const btn = (listeners = {}) =>
      h(
        VBtn,
        {
          attrs: {
            color,
            small: true,
            icon: true,
            to,
            href,
            target,
            disabled,
            loading
          },
          on: { ...listeners, click: () => this.$emit("click") }
        },
        [icon]
      );

    let content = null;

    if (tooltip) {
      content = h(VTooltip, {
        attrs: { bottom: true },
        scopedSlots: {
          default() {
            return tooltip;
          },
          activator({ on }) {
            return btn(on);
          }
        }
      });
    } else {
      content = btn();
    }

    return h("div", { class: "sv-action-col-btn" }, [content]);
  }
};
</script>
